var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormatListBulleted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16797 4.49805C2.16797 3.94471 2.61464 3.49805 3.16797 3.49805C3.7213 3.49805 4.16797 3.94471 4.16797 4.49805C4.16797 5.05138 3.7213 5.49805 3.16797 5.49805C2.61464 5.49805 2.16797 5.05138 2.16797 4.49805ZM2.16797 8.49805C2.16797 7.94471 2.61464 7.49805 3.16797 7.49805C3.7213 7.49805 4.16797 7.94471 4.16797 8.49805C4.16797 9.05138 3.7213 9.49805 3.16797 9.49805C2.61464 9.49805 2.16797 9.05138 2.16797 8.49805ZM3.16797 11.498C2.61464 11.498 2.16797 11.9514 2.16797 12.498C2.16797 13.0447 2.6213 13.498 3.16797 13.498C3.71464 13.498 4.16797 13.0447 4.16797 12.498C4.16797 11.9514 3.7213 11.498 3.16797 11.498ZM14.5013 13.1647H5.16797V11.8314H14.5013V13.1647ZM5.16797 9.16471H14.5013V7.83138H5.16797V9.16471ZM5.16797 5.16471V3.83138H14.5013V5.16471H5.16797Z",
    fill: "#454A54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatListBulleted);
export default __webpack_public_path__ + "static/media/format-list-bulleted.6d0aa88ccb944a9913d71f4a4f0dc672.svg";
export { ForwardRef as ReactComponent };